<template>
    <div class="page-price-overview-widget">
        <div class="search-component">
            <slot></slot>
            <price-overview-widget :set-form="setForm"></price-overview-widget>
        </div>
    </div>
</template>

<script type="text/javascript">
    import PriceOverviewWidget from './price-overview-widget.vue';

    export default {
        props: {
            form: {type: String, default: ''}
        },
        computed: {
            setForm() {
                return (this.form) ? JSON.parse(this.form) : null;
            }
        },
        components: {
            PriceOverviewWidget
        }
    }
</script>